import React from "react";
import {
    Avatar,
    AvatarGroup,
    Box,
    Chip,
    Grid,
    Stack,
    Typography,
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialDatePicker from "../../../../components/MaterialDatePicker";

const ProjectHeaderCard = () => {
    return (
        <MaterialBox
            sx={{
                // padding: 1,
                // backgroundColor: "#fff",
                // borderRadius: 3,
                // boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
            }}
        >
            <Grid container alignItems="center" spacing={2}>
                <Grid size={{ xs: 12, md: 7, lg: 7 }}>
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        alignItems={{ xs: "flex-start", sm: "center" }}
                        spacing={1}
                    >
                        <Avatar
                            src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                            alt="Project Logo"
                            sx={{ width: 56, height: 56, bgcolor: "transparent" }}
                            imgProps={{ style: { objectFit: "contain" } }}
                        />

                        <Box>
                            <Typography variant="h6" fontWeight="bold" color="text.primary">
                                Project Alpha
                            </Typography>

                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                                mt={1}
                                flexWrap="wrap"
                                useFlexGap
                            >
                                <Chip
                                    label="In Progress"
                                    size="small"
                                    sx={{
                                        backgroundColor: "#ffece6",
                                        color: "#ff5c35",
                                        fontWeight: "600",
                                        borderRadius: "8px",
                                        height: "26px",
                                        "& .MuiChip-label": {
                                            paddingLeft: "12px",
                                            paddingRight: "12px",
                                        },
                                    }}
                                />

                                <Box
                                    sx={{
                                        width: "1px",
                                        height: "20px",
                                        backgroundColor: "#e0e0e0",
                                        display: { xs: "none", sm: "block" },
                                    }}
                                />

                                <AvatarGroup
                                    max={4}
                                    sx={{
                                        "& .MuiAvatar-root": {
                                            width: 28,
                                            height: 28,
                                            fontSize: 12,
                                            border: "2px solid #fff",
                                        },
                                    }}
                                >
                                    <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                                    <Avatar
                                        alt="Travis Howard"
                                        src="/static/images/avatar/2.jpg"
                                    />
                                    <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                                    <Avatar
                                        alt="Agnes Walker"
                                        src="/static/images/avatar/4.jpg"
                                    />
                                    <Avatar
                                        alt="Trevor Henderson"
                                        src="/static/images/avatar/5.jpg"
                                    />
                                </AvatarGroup>
                            </Stack>
                        </Box>
                    </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 5, lg: 5 }}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent={{ xs: "flex-start", md: "flex-end" }}
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0.5}>
                            <Typography variant="caption" fontWeight="bold" color="text.secondary" ml={1}>
                                Start Date
                            </Typography>
                            <MaterialDatePicker
                                input={{
                                    placeholder: "Select Date",
                                    size: "small",
                                    sx: {
                                        width: "80px",
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "20px",
                                        },
                                    },
                                }}
                            />
                        </Stack>

                        <Stack direction="column" spacing={0.5}>
                            <Typography variant="caption" fontWeight="bold" color="text.secondary" ml={1}>
                                End Date
                            </Typography>
                            <MaterialDatePicker
                                input={{
                                    placeholder: "Select Date",
                                    size: "small",
                                    sx: {
                                        width: "80px",
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "20px",
                                        },
                                    },
                                }}
                            />
                        </Stack>

                    </Stack>
                </Grid>
            </Grid>
        </MaterialBox>
    );
};

export default ProjectHeaderCard;